const baseStyle = {
  color: `heading`,
  fontFamily: `body`,
  fontWeight: `medium`,
};

const sizes = {
  xxs: {
    fontSize: `xxs`,
  },
  xs: {
    fontSize: `xs`,
  },
  sm: {
    fontSize: `sm`,
  },
  md: {
    fontSize: `md`,
  },
  lg: {
    fontSize: [`md`, null, `lg`],
  },
  xl: {
    fontSize: [`lg`, null, `xl`],
  },
};
const variants = {
  preHeader: {
    textTransform: `uppercase`,
    letterSpacing: `2px`,
    mb: `2`,
    display: `block`,
  },
  preHeaderBorder: {
    textTransform: `uppercase`,
    letterSpacing: `2px`,
    mb: `2`,
    display: `block`,
    pb: `4`,
    borderBottom: `1px solid hsl(0, 0%, 65%)`,
    color: `gray.lighter`,
  },
  preHeaderBorderHeavierGray: {
    textTransform: `uppercase`,
    letterSpacing: `2px`,
    mb: `2`,
    display: `block`,
    pb: `4`,
    fontWeight: '600',
    borderBottom: `1px solid hsl(0, 0%, 65%)`,
    color: `gray`,
  },
};

export const Text = {
  baseStyle,
  sizes,
  variants,
};
